// @ts-check
import { route } from './author.js';
export const THERMAL_LEVELS = [
  route(6, 1, 'Cool Start', 'Cooling columns lift QP. Airflow shows when the fans are active.', 148)
    .node(9).device('vent', 17, 0, 3, 6, 6).platform(23, 4, 5, 0.5).node(26, 6, 'overclock')
    .bot(35).gap(40, 3).checkpoint(48, 'Cooling channel').device('vent', 55, 0, 4, 7, 6)
    .platform(63, 5, 5, 0.5).node(69, 7, 'bit').device('vent', 76, 0, 3, 5, 6, { offset: 2 })
    .platform(83, 3, 4, 0.5).checkpoint(94, 'Intake').node(100).gap(108, 5)
    .device('vent', 106, 0, 8, 5, 6).platform(120, 2, 4, 0.5).bot(132, 0, true).build(),
  route(6, 2, 'Load Spike', 'Heat strips warn before firing. Use the cool columns and shielded ledges.', 158)
    .node(9).device('scanner', 17, 0, 8, 0.6, 5).platform(23, 0, 1, 1)
    .device('vent', 30, 0, 3, 6, 6).platform(36, 4, 4, 0.5).checkpoint(47, 'Cool boundary')
    .device('scanner', 54, 0, 10, 0.6, 5).platform(61, 0, 1, 1)
    .device('carrier', 68, 1, 3, 0.5, 5, { travelX: 6, travelY: 2 }).node(79, 5, 'overclock')
    .bot(85).checkpoint(95, 'Load monitor').node(102).device('vent', 110, 0, 4, 7, 6)
    .platform(117, 5, 5, 0.5).device('scanner', 127, 0, 10, 0.6, 5).platform(134, 0, 1, 1).bot(145).build(),
  route(6, 3, 'Thermal Throttle', 'Climb the cooling fins. Time the vents to stay above the hot bus.', 168)
    .node(9).device('vent', 17, 0, 3, 7, 6).platform(24, 4, 4, 0.5)
    .device('vent', 31, 0, 3, 8, 6, { offset: 1 }).platform(38, 6, 4, 0.5)
    .node(40, 8, 'overclock').checkpoint(49, 'Thermal reserve')
    .device('scanner', 56, 0, 11, 0.6, 6).platform(64, 0, 1, 1).device('vent', 71, 0, 3, 8, 6)
    .platform(78, 5, 4, 0.5).device('carrier', 85, 3, 3, 0.5, 6, { travelY: 3 })
    .checkpoint(96, 'Emergency intake').node(103).gap(112, 6).device('vent', 110, 0, 9, 7, 6)
    .platform(124, 3, 4, 0.5).device('vent', 132, 0, 3, 8, 6, { offset: 2 })
    .platform(139, 5, 5, 0.5).node(143, 7, 'overclock').bot(155, 0, true).build(),
  route(6, 4, 'Emergency Cooling', 'Read the hot vent warnings. Strike Heatsink during its cooling cycle.', 112)
    .node(9).device('vent', 17, 0, 3, 6, 6).platform(24, 4, 4, 0.5)
    .device('scanner', 33, 0, 9, 0.6, 5).platform(40, 0, 1, 1)
    .device('carrier', 47, 1, 3, 0.5, 5, { travelY: 3 }).node(54, 5, 'overclock').bot(63)
    .boss('heatsink', 'Heatsink').build(),
];
